/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, Suspense } from "react";
import { PageLoader } from "../PageLoader";

type TLazyLoaderComponent<T> = (props: T) => any;

export function LazyLoader<T = any>(Component: React.LazyExoticComponent<FunctionComponent<T>>): TLazyLoaderComponent<T> {
  return (props: any) => (
    <Suspense fallback={<PageLoader />}>
      <Component {...props} />
    </Suspense>
  )
};